var _defs, _path, _rect, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path7, _path8, _polygon6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 666.33 237.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00b050;}.cls-2{fill:#44546a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.09,32.22C1.7,28.83,0,24.31,0,18.65S1.7,8.48,5.09,5.09C8.48,1.7,13.24,0,19.38,0s10.66,1.7,14.05,5.09c3.39,3.39,5.09,7.91,5.09,13.56s-1.7,10.17-5.09,13.57c-3.39,3.39-8.08,5.09-14.05,5.09s-10.9-1.7-14.29-5.09Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.66,
    y: 53.78,
    width: 33.43,
    height: 123.78
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m63.17,177.56V61.53c16.63-7.11,34.88-10.66,54.75-10.66,17.76,0,31.49,4.28,41.18,12.84,9.69,8.56,14.54,20.83,14.54,36.82v77.03h-33.43v-74.61c0-16.31-7.51-24.47-22.53-24.47-7.91,0-15.02,1.45-21.32,4.36v94.72h-33.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m305.41,105.86c0,5.81-.33,11.95-.97,18.41h-76.55c3.07,18.74,14.37,28.1,33.91,28.1,11.3,0,22.53-2.34,33.67-7.03l5.33,26.89c-12.11,5.49-26.25,8.24-42.39,8.24-19.7,0-35.57-5.85-47.6-17.56-12.03-11.71-18.05-27.49-18.05-47.36s5.57-34.8,16.71-46.75c11.14-11.95,25.59-17.92,43.36-17.92,15.82,0,28.54,5.09,38.15,15.26,9.61,10.17,14.41,23.42,14.41,39.73Zm-31.98-1.94v-2.91c0-6.94-1.82-12.6-5.45-16.96-3.63-4.36-8.68-6.54-15.14-6.54-6.95,0-12.64,2.34-17.08,7.02-4.44,4.69-7.23,11.14-8.36,19.38h46.03Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m403.56,85.02c-14.37-4.36-25.6-6.54-33.67-6.54-11.3,0-16.96,3.31-16.96,9.93,0,3.39,1.37,5.93,4.12,7.63,2.74,1.7,8.07,3.67,15.99,5.93,14.69,4.04,25.23,8.92,31.61,14.66,6.38,5.74,9.57,14.01,9.57,24.83,0,12.6-4.64,22.25-13.93,28.95-9.29,6.7-21.6,10.05-36.94,10.05-16.96,0-31.57-2.67-43.85-8l4.6-27.37c13.4,5.17,26.24,7.75,38.52,7.75,5.65,0,10.21-.93,13.69-2.79,3.47-1.85,5.21-4.48,5.21-7.87,0-3.71-1.66-6.5-4.97-8.36-3.31-1.85-10.29-4.32-20.95-7.39-11.79-3.07-20.67-7.51-26.65-13.32-5.98-5.81-8.96-13.81-8.96-23.98,0-12.27,4.16-21.72,12.48-28.34,8.32-6.62,19.9-9.93,34.76-9.93s28.18,2.34,39.97,7.02l-3.63,27.13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m523.63,58.14l-6.3,26.4c-9.53-4.03-18.65-6.06-27.37-6.06-9.69,0-17.16,3.23-22.41,9.69-5.25,6.46-7.87,15.42-7.87,26.89,0,25.19,10.66,37.79,31.98,37.79,8.56,0,17.52-2.1,26.89-6.3l5.33,26.89c-9.37,4.68-21,7.03-34.88,7.03-20.03,0-35.61-5.77-46.75-17.32-11.14-11.54-16.71-27.25-16.71-47.12s5.49-35.69,16.47-47.48c10.98-11.79,26-17.68,45.06-17.68,13.89,0,26.08,2.42,36.58,7.27Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m619.26,139.54c-12.45,9.44-30.27,8.49-41.63-2.87-11.36-11.36-12.31-29.17-2.87-41.63l-24.5-24.5c-22.85,26.03-21.87,65.69,2.98,90.53,24.84,24.84,64.5,25.83,90.53,2.98l-24.51-24.51Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 563.25,
    y: 62.27,
    width: 4.37,
    height: 34.51,
    transform: "translate(109.37 423.11) rotate(-45)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 569.8,
    y: 56.78,
    width: 4.37,
    height: 34.51,
    transform: "translate(61.01 341.53) rotate(-35.01)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 577.2,
    y: 52.51,
    width: 4.37,
    height: 34.51,
    transform: "translate(24.87 251.61) rotate(-25.02)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 585.23,
    y: 49.59,
    width: 4.37,
    height: 34.51,
    transform: "translate(2.73 154.42) rotate(-15.01)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 593.65,
    y: 48.1,
    width: 4.37,
    height: 34.51,
    transform: "translate(-3.43 52.21) rotate(-5)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 587.12,
    y: 63.17,
    width: 34.51,
    height: 4.37,
    transform: "translate(486.55 661.73) rotate(-85)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 595.54,
    y: 64.66,
    width: 34.51,
    height: 4.37,
    transform: "translate(389.64 641.46) rotate(-75)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 603.57,
    y: 67.58,
    width: 34.51,
    height: 4.37,
    transform: "translate(295.29 602.98) rotate(-65.01)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 610.97,
    y: 71.85,
    width: 34.51,
    height: 4.37,
    transform: "translate(207.3 546.23) rotate(-55.01)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 617.52,
    y: 77.35,
    width: 34.51,
    height: 4.37,
    transform: "translate(129.61 472.05) rotate(-44.99)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 623.01,
    y: 83.89,
    width: 34.51,
    height: 4.37,
    transform: "translate(66.34 382.65) rotate(-34.98)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 627.28,
    y: 91.29,
    width: 34.51,
    height: 4.36,
    transform: "translate(20.93 281.3) rotate(-25.01)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 630.21,
    y: 99.33,
    width: 34.51,
    height: 4.36,
    transform: "translate(-4.21 171.08) rotate(-15)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 631.69,
    y: 107.74,
    width: 34.51,
    height: 4.37,
    transform: "translate(-7.1 56.86) rotate(-4.99)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 646.76,
    y: 101.22,
    width: 4.37,
    height: 34.51,
    transform: "translate(474.47 754.65) rotate(-85.01)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 645.28,
    y: 109.63,
    width: 4.37,
    height: 34.51,
    transform: "translate(357.3 719.43) rotate(-75)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 642.36,
    y: 117.66,
    width: 4.36,
    height: 34.51,
    transform: "translate(249.72 661.94) rotate(-64.98)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "627.39 130.63 624.88 134.21 653.15 154 655.65 150.43 627.39 130.63"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "624.12 135.12 621.03 138.21 645.43 162.61 648.51 159.53 624.12 135.12"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.11 224.67 23.78 224.67 23.78 217.79 9.11 217.79 9.11 212.81 34.28 212.81 34.28 205.78 0 205.78 0 237.83 34.64 237.83 34.64 230.59 9.11 230.59 9.11 224.67"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "152.16 225.12 127.45 205.78 121.25 205.78 121.25 237.83 129.57 237.83 129.57 218.21 154.04 237.65 154.26 237.83 160.48 237.83 160.48 205.78 152.16 205.78 152.16 225.12"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "256.21 224.67 270.87 224.67 270.87 217.79 256.21 217.79 256.21 212.81 281.37 212.81 281.37 205.78 247.1 205.78 247.1 237.83 281.73 237.83 281.73 230.59 256.21 230.59 256.21 224.67"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m396.55,226.32c2.66,0,4.58-.49,5.89-1.5,1.36-1.04,2.04-2.78,2.04-5.14v-7.19c0-2.41-.69-4.17-2.04-5.21-1.31-1.01-3.24-1.5-5.89-1.5h-28.21v32.05h8.97v-11.5h5.84l12.73,11.5h13.29l-14.45-11.5h1.83Zm-19.24-13.66h16.08c1.19,0,1.82.2,2.13.37.29.16.44.58.44,1.26v3.52c0,.68-.15,1.1-.44,1.26-.31.17-.93.37-2.13.37h-16.08v-6.78Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m533.12,207.31c-1.36-1.03-3.52-1.53-6.61-1.53h-22c-1.53,0-2.85.11-3.91.34-1.14.24-2.08.68-2.8,1.29-.75.63-1.28,1.51-1.59,2.59-.29,1.01-.43,2.25-.43,3.78v16.03c0,1.53.14,2.76.43,3.75.3,1.05.82,1.92,1.52,2.57.71.65,1.65,1.1,2.79,1.35,1.06.23,2.4.34,3.98.34h22c1.53,0,2.86-.11,3.94-.34,1.17-.24,2.12-.7,2.83-1.35.71-.65,1.22-1.52,1.52-2.57.28-.98.43-2.24.43-3.75v-11.31h-20.97v7.03h12.08v4.84h-21.52v-17.35h21.52v3.38l8.89-1.5v-1.48c0-3.03-.69-5.03-2.12-6.11Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "655.32 205.78 644.66 216.78 634.15 205.78 621.85 205.78 639.6 223.69 639.6 237.83 648.64 237.83 648.64 223.54 666.33 205.78 655.32 205.78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.61944e703e5d74305e6430512bd3d1c4.svg";
export { ForwardRef as ReactComponent };